import jwt from '@/auth/jwt/useJwt'
import { computed, ref } from '@vue/composition-api'
import Vue from 'vue'

export default function Organizers() {
  const route = 'organizer'
  const organizer = ref({ })

  const formattedOrganizer = computed(() => ({
    ...organizer.value,
    organization_id: Vue.prototype.$orgId,
    image: organizer.value.image?.id,
  }))

  const indexRequest = params => jwt.axiosIns.get(route, { params }).then(res => res).catch(() => [])

  const showRequest = (id, params) => jwt.axiosIns.get(`${route}/${id}`, { params }).then(res => res).catch(() => [])

  const storeRequest = () => jwt.axiosIns.post(route, formattedOrganizer.value).then(res => res)

  const updateRequest = () => jwt.axiosIns.put(`${route}/${organizer.value.id}`, formattedOrganizer.value).then(res => res)

  const destroyRequest = id => jwt.axiosIns.delete(`${route}/${id}`).then(res => res)

  return {
    organizer, indexRequest, showRequest, storeRequest, updateRequest, destroyRequest,
  }
}
